import { HttpClient, HttpXsrfTokenExtractor } from '@angular/common/http';
import {Component, NgZone, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import { AdminNotification, getAdminNotificationCount } from '@data/notification/admin-notification';
import { AdminNotificationService } from '@data/notification/admin-notification.service';
import { AuthService } from '@modules/auth/services/auth.service';
import { CommonConstants } from '@mpg-core/constants/common-constants';
import {CommonDataService} from '@shared/services/common-data.service';
import { PermissionService } from '@shared/services/permission.service'; // Generated by Copilot
// import {Auth} from 'aws-amplify';
import { DxMenuTypes } from 'devextreme-angular/ui/menu';

@Component({
    selector: 'app-header', templateUrl: './header.component.html', styleUrls: ['./header.component.less'],
    standalone: false
})
export class HeaderComponent implements OnInit {
    
  userName : any;

  menuAccess: any;

  menuItems : any = [];
  submenuMode = [
    {
      name: 'onHover' as DxMenuTypes.SubmenuShowMode ,
      delay: { show: 0, hide: 300 },
    }, {
      name: 'onClick' as DxMenuTypes.SubmenuShowMode,
      delay: { show: 0, hide: 300 },
    }
  ];

  isAdminThere : boolean=false;
  isAuthShow : boolean;
  userEmail : any;

  adminNotificationList: AdminNotification[]=[];
  adminTotalNotificationCount:number=0; 
  adminManageReleaseDateNotificationCount:number=0; 


  constructor(private router : Router, private http : HttpClient, private xsrfTokenExractor : HttpXsrfTokenExtractor, private commonServices : CommonDataService, private zone : NgZone, private _adminNotfy: AdminNotificationService,
    private authService:AuthService, private permissionService: PermissionService) { 
      const getAccess = this.commonServices.checkAuth;
      if(!getAccess.value){
        this.commonServices.checkAuth.next(JSON.parse(window.localStorage.getItem("mp-serve-auth") || "[]"));
        this.commonServices.userData.next(JSON.parse(window.localStorage.getItem("mpuserdetailslock") || "[]"));
        this.commonServices.userInfo.next(JSON.parse(window.localStorage.getItem("mpUInfo") || "[]"));
      }
      
    this.userName = this.commonServices.userInfo.value.firstName +" "+ this.commonServices.userInfo.value.lastName ;    
    // Permission checks — use numeric permissionId via PermissionService — Generated by Copilot
    if(!this.permissionService.hasNoAccess('Home')){
      this.menuItems.push({
        id: 'home',
        name: 'Home',
        url: 'home'
    })
    }
    if(!this.permissionService.hasNoAccess('Search')){
      this.menuItems.push({
        id: 'search',
        name: 'Search',
        url: 'search'
    })
    }
    if(!this.permissionService.hasNoAccess('Production Status Report') || !this.permissionService.hasNoAccess('Weekly Variance Report') || !this.permissionService.hasNoAccess('Post-Production Summary Report')){
      this.menuItems.push({
        id: 'reports',
        name: 'Reports',
        url: 'reports',
        items: [
          {
            id: 'preview',
            name: 'Production/Post-Production',
            url: 'reports/preview'
          }
        ]
    })
      if (this.commonServices.userInfo.value.userRole.roleId === CommonConstants.FINANCE_AUDITOR_ROLE_ID 
        || this.commonServices.userInfo.value.userRole.roleId === CommonConstants.SUPER_ADMIN_ROLE_ID
        || this.commonServices.userInfo.value.userRole.roleId === CommonConstants.FINANCE_EXEC_ROLE_ID 
        || this.commonServices.userInfo.value.userRole.roleId === CommonConstants.IT_READ_ONLY_ROLE_ID) {
          let data = {
              id: 'gv-sap-recon',
              name: 'GV SAP Recon',
              url: 'reports/gv-sap-recon'
          }

          for (let m of this.menuItems) {
              if (m.id == 'reports') {
                  m.items.push(data);
                  break;
              }
          }
      }

      
    }
    
    if(!this.permissionService.hasNoAccess('Admin')
    && this.commonServices.userInfo.value.userRole.roleId != CommonConstants.FINANCE_AUDITOR_ROLE_ID){
      this.isAdminThere=true;
      this.menuItems.push({
        id: 'admin',
        name: 'Admin',
        url: 'admin',
        items: [{
          id: 'manage-publish-dist',
          name: 'Manage Publish',
          url: 'admin/manage-publish-dist'
        },
        {
          id: 'aduit-reports',
          name: 'Audit Reports',
          url: 'admin/audit-logs'
        },
        {
          id: 'manage-projects',
          name: 'Manage Projects',
          url: 'admin/manage-projects'
        },
        {
          id: 'manage-production-entity',
          name: 'Manage Production Entity',
          url: 'admin/manage-production-entity'
        },
        {
          id: 'manageUsers',
          name: 'Manage Users',
          url: 'admin/user/manage-user'
        },
        {
          id: 'pick-list-admin',
          name: 'Picklist Admin',
          url: 'admin/pick-list'
        },
        {
          id: 'manage-release-date',
          name: 'Manage Release Date',
          url: 'admin/manage-release-date'
        }
      ]
      });
      
    }

    if(this.commonServices.userInfo.value.userRole.roleId === CommonConstants.FINANCE_AUDITOR_ROLE_ID){
      
      this.menuItems.push({
        id: 'admin',
        name: 'Admin',
        url: 'admin',
        items: [{
          id: 'manage-publish-dist',
          name: 'Manage Publish',
          url: 'admin/manage-publish-dist'
        },
        {
          id: 'aduit-reports',
          name: 'Audit Reports',
          url: 'admin/audit-logs'
        }]
      });
    }
      
    if(this.commonServices.userInfo.value.userRole.roleId === CommonConstants.POST_PRODUCTION_ADMIN
      || this.commonServices.userInfo.value.userRole.roleId === CommonConstants.POST_PRODUCTION_ADMIN_ROLE_READ_ONLY_ID){  
      
        this.menuItems.push({
          id: 'admin',
          name: 'Admin',
          url: 'admin',
          items: [{
            id: 'pick-list-admin',
            name: 'Picklist Admin',
            url: 'admin/pick-list'
          },{
            id: 'manage-release-date',
            name: 'Manage Release Date',
            url: 'admin/manage-release-date'
          }]
        });
        this.fetchAdminNotification();      
        _adminNotfy.fetchInterplanData();
    }


          
  }

  ngOnInit(): void {}

  isShowMenu : any = false;

  Navigate(option : string) {
    if(option=='admin')
      return;
    this.isShowMenu=false;
    this.zone.run(() => {
        this.router.navigate([option]);
    });
  }

  isActive(option : string) { 
    if(this.router.url.slice(1,option.length+1) == option){
      return true;
    }
    return false;
  }



  fetchAdminNotification(){
    this._adminNotfy.isAdminNotificationUpdated.subscribe(r=>{
      if(r){
        this.adminNotificationList=this._adminNotfy.adminNotificationList;
        this.adminTotalNotificationCount=getAdminNotificationCount(this.adminNotificationList,'tabCount',null,null);
        this.adminManageReleaseDateNotificationCount=getAdminNotificationCount(this.adminNotificationList,'tabWise',['manageReleaseDate'],null);
      }
    });
  }

  signOut() {
    this.authService.logout();
  }

}
      

